import AdvantageCard from "../Utils/AdvantageCard"

const Advantages=()=>
{
    let data=[
        {"title":"Onboarding made easy",
        "bulletdata":[
            "Homeowner-driven onboarding system",
            "3D virtual home tours",
            "Custom copywriting",
            "High-definition photography",
        ]
    },
    {
        "title":"Listing on BRIK itt Portal",
        "bulletdata":[
        "Higher Footfall",
        "Managing OTAs listings",
        "Less Commission than OTAs",
        "24/7 Concierge Services",]
    },
    {
        "title":"Taking care of your Home",
        "bulletdata":[
        "Daily Housekeeping Service",
        "30 Day rental distribution",
        "Pest Control (Every 60 Days)",
        "Inventory Management",
        "Timely Maintenance of Equipment"]
    },
    {
        "title":"Guest Services","bulletdata":
        ["24/7 Check-in Check-out service",
        "On call Assistance",
        "Value added services for guest",
        "Chef on Demand",]
    }
    ]
    return(
        <div style={{background: "linear-gradient(180deg, rgba(1, 1, 1, 0.80) 0%, rgba(1, 1, 1, 0.45) 100%), #574B3D"}} className=" sm:py-[30px] sm:px-[16px] lg:py-[80px] lg:px-[158px]">
            <p style={{fontFamily:"Playfair Display"}} className="text-white sm:text-[22px] lg:text-[35px] font-[600] sm:leading-[30px] lg:leading-[56px] tracking-[0.5px] sm:pb-[15px] lg:pb-[20px]">BRIK itt Offerings</p>
            <p style={{fontFamily:"Inter"}} className="sm:text-[16px] lg:text-[22px] font-[400] leading-[22px] text-white opacity-[70%] sm:pb-[35px] lg:pb-[40px]">Your time is valuable. Here’s how we make your experience smooth from end to end.</p>
            <div style={{fontFamily:"Inter"}} className="sm:block lg:grid grid-cols-2 gap-x-[65px] gap-y-[40px]">
                {
                    data?.map((e,i)=>
                    {
                        return <AdvantageCard key={i} title={e.title} bulletdata={e.bulletdata} />
                    })
                }
            </div>
        </div>
    )
}
export default Advantages